import { render, staticRenderFns } from "./StepButton.vue?vue&type=template&id=23de34e2"
import script from "./StepButton.vue?vue&type=script&lang=js"
export * from "./StepButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports